import {
    SET_LOYALTY_SETTINGS,
    UPDATE_LOYALTY_SETTINGS,
    SET_LOYALTY_LOADING,
    SET_LOYALTY_ERROR,
    RESET_LOYALTY_STATE,
    UPDATE_LOYALTY_SYSTEM_TYPE,
    UPDATE_REWARDS_CATALOG,
    UPDATE_TIER_CONFIGURATION,
    UPDATE_GAMIFICATION_SETTINGS,
} from '../types/loyalty';

const initialState = {
    loading: false,
    error: null,
    settings: {
        // Primary system selection
        loyalty_system_type: 'cashback', // 'cashback' or 'points'

        // Cashback settings
        enable_cashback: false,
        cashback_earning_percentage: 5,
        cashback_expiration_days: 30,
        cashback_signup_bonus: 50,

        // Points settings
        enable_points: false,
        points_earning_rule_amount: 100,
        points_earning_rule_points: 1,
        points_expiration_days: 365,
        points_signup_bonus: 100,
        calculate_points_after_discount: true,
        universal_earning_rule: true,

        // Rewards catalog
        rewards_catalog: [],
        out_of_stock_behavior: 'show_out_of_stock',

        // Gamification settings
        enable_daily_rewards: false,
        daily_reward_mechanism: 'scratch_card',
        daily_reward_min: 0,
        daily_reward_max: 10,

        enable_streaks: false,
        streak_rewards: [],

        // Challenges
        enable_referral_challenge: false,
        referral_challenge_reward: 50,

        enable_order_frequency_challenge: false,
        order_frequency_count: 5,
        order_frequency_days: 7,
        order_frequency_reward: 100,

        enable_order_diversity_challenge: false,
        order_diversity_reward: 150,

        enable_profile_completion_challenge: false,
        profile_completion_reward: 25,

        // Tier system
        enable_tier_system: false,
        tier_count: 3,
        tier_downgrade_period_days: 365,
        tiers: [],

        // Per-mode configuration
        same_redemption_all_modes: true,
        ordering_mode_configurations: [],

        // Earnings delay
        same_delay_all_modes: true,
        earnings_delay_configurations: [],
    },
};

const loyaltyReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LOYALTY_SETTINGS:
            return {
                ...state,
                settings: action.payload,
                loading: false,
                error: null,
            };

        case UPDATE_LOYALTY_SETTINGS:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    ...action.payload,
                },
            };

        case SET_LOYALTY_LOADING:
            return {
                ...state,
                loading: action.payload,
            };

        case SET_LOYALTY_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };

        case UPDATE_LOYALTY_SYSTEM_TYPE:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    loyalty_system_type: action.payload,
                    // Reset system-specific enables
                    enable_cashback: action.payload === 'cashback',
                    enable_points: action.payload === 'points',
                },
            };

        case UPDATE_REWARDS_CATALOG:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    rewards_catalog: action.payload,
                },
            };

        case UPDATE_TIER_CONFIGURATION:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    tiers: action.payload.tiers,
                    tier_count: action.payload.tier_count,
                },
            };

        case UPDATE_GAMIFICATION_SETTINGS:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    ...action.payload,
                },
            };

        case RESET_LOYALTY_STATE:
            return initialState;

        default:
            return state;
    }
};

export default loyaltyReducer;
